import { INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";
import { PickupPlacement } from "./PickupPlacement";

export class FireBootsPickupPlacement extends PickupPlacement {
  addsItemToInventoryOnCollide(body) {
    if (body.type === PLACEMENT_TYPE_HERO) {
      return INVENTORY.FIRE_PICKUP;
    }
    return null;
  }

  canBeStolen() {
    return true;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.FIRE_PICKUP} />;
  }
}
